import { render, staticRenderFns } from "./HowDoesItLook.vue?vue&type=template&id=06bbd012&"
import script from "./HowDoesItLook.vue?vue&type=script&lang=js&"
export * from "./HowDoesItLook.vue?vue&type=script&lang=js&"
import style0 from "./HowDoesItLook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports